import React from "react";
import { connect } from "react-redux";
import GroheRoomPreset from "./groheRoomPreset";

const GroheRoomIdeasContent = (props) => {

  const {bvPresets} = props;

  return (
    <div className="grohe-section__content grohe-section__content--with-padding">
      <ul className="grohe-rooms">
        {bvPresets.map((roomPreset, lookIndex) => {
          return <GroheRoomPreset key={lookIndex} roomPreset={roomPreset}/>
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {bvPresets} = store.bathroomVisualizerState;
  return {
    bvPresets,
  };
};

export default connect(mapStateToProps)(GroheRoomIdeasContent)
